export const formatTime = (time: number | string, isArmyTime: boolean = true): string => {
    if (time?.toString() === '0000' || !time) return 'TBD';
    if (time === 'TBD') return 'TBD';
    let timeStr = time?.toString()?.padStart(4, '0');

    if (!isArmyTime) {
        const colonPosition = timeStr?.length === 3 ? 1 : 2;
        timeStr = `${timeStr?.substr(0, colonPosition)}:${timeStr?.substr(colonPosition)}`;

        let hours = parseInt(timeStr?.substr(0, 2), 10);
        let minutes = timeStr?.substr(3, 2);
        const ampm = hours >= 12 ? 'pm' : 'am';

        hours = hours % 12 || 12;
        minutes = +minutes === 0 ? '00' : minutes;

        return `${hours}:${minutes} ${ampm}`;
    } else {

        let timeStr = time?.toString().padStart(4, '0');
        let hours = parseInt(timeStr?.substr(0, 2), 10);
        let minutes = timeStr?.substr(2, 2);
        const ampm = hours >= 12 ? 'pm' : 'am';

        hours = hours % 12 || 12;
        minutes = +minutes === 0 ? '00' : minutes;

        return `${hours}:${minutes} ${ampm}`;
    }
}

export const formatDateToMonthDay = (dateNumber: number, includeYear: boolean = false): string => {
    if (!dateNumber) return 'no date';
    const dateString = dateNumber.toString();

    if (dateString.length !== 8) {
        throw new Error("Invalid date format. Expected format: YYYYMMDD as an 8-digit number.");
    }

    const year = dateString.substr(0, 4);
    const month = parseInt(dateString.substr(4, 2), 10) - 1;
    const day = parseInt(dateString.substr(6, 2), 10);

    const date = new Date(+year, month, day);

    const monthName = date.toLocaleString('en-US', { month: 'long' });

    const getOrdinalSuffix = (n: number): string => {
        const s = ["th", "st", "nd", "rd"];
        const v = n % 100;
        return n + (s[(v - 20) % 10] || s[v] || s[0]);
    };

    const dayWithSuffix = getOrdinalSuffix(day);

    // Construct the formatted date
    return includeYear ? `${monthName} ${dayWithSuffix}, ${year}` : `${monthName} ${dayWithSuffix}`;
};

export const isTokenExpired = (token: any) => {
    if (!token || !token.exp) return true;

    const currentTimeInSeconds = Math.floor(Date.now() / 1000);
    return token.exp < currentTimeInSeconds;
}

export const getNbaSeason = (pastSeasons = 0) => {
    const dt = new Date();
    const yr = dt.getFullYear();
    const mnth = dt.getMonth();
    if (mnth > 9) return yr - pastSeasons;
    return yr - 1 - pastSeasons;
}


export const get8DigitDate = (daysAgo = 0): string => {
    const date = new Date()
    date.setDate(date.getDate() - daysAgo)

    const year = date.getFullYear()
    const month = date.getMonth() + 1
    const day = date.getDate()

    return `${year}${month < 10 ? `0${month}` : month}${day < 10 ? `0${day}` : day}`
}


export const getNflSeason = (pastSeasons = 0) => {
    const dt = new Date();
    const mnth = dt.getMonth();
    let yr = dt.getFullYear();

    if (mnth >= 8 && mnth <= 11) {
        return yr - pastSeasons;
    }

    if (mnth <= 7) {
        return yr - 1 - pastSeasons;
    }

    return yr - pastSeasons;
};

export const getNcaafbSeason = (pastSeasons = 0) => {
    const dt = new Date();
    const mnth = dt.getMonth();
    let yr = dt.getFullYear();

    if (mnth >= 7 && mnth <= 11) {
        return yr - pastSeasons;
    }

    if (mnth <= 6) {
        return yr - 1 - pastSeasons;
    }

    return yr - pastSeasons;
};